import { CLOSE_NO_LOCATION_POINT_TOAST } from '@shopDetails/actionTypes';

const closeNoLocationPointToast = () => ({
  type: CLOSE_NO_LOCATION_POINT_TOAST,
});

export default closeNoLocationPointToast;
